import { render, staticRenderFns } from "./UsersProfile.vue?vue&type=template&id=84d60524&scoped=true&"
import script from "./UsersProfile.vue?vue&type=script&lang=js&"
export * from "./UsersProfile.vue?vue&type=script&lang=js&"
import style0 from "./UsersProfile.vue?vue&type=style&index=0&id=84d60524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d60524",
  null
  
)

export default component.exports